import { _ as a } from "./index.es376.js";
var t = a;
function s() {
  this.__data__ = new t(), this.size = 0;
}
var e = s;
export {
  e as _
};
//# sourceMappingURL=index.es377.js.map
